import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, EditIcon, Text } from '@mercai/clever'
import { CustomAccordion } from '@/components'

import { ProfileProductsIndustryProps } from './products-industry.type'
import styles from './products-industry.module.css'
import { checkIfProductsIndustryIsComplete } from '../../general.constants'

export const ProfileProductsIndustry = ({
  lead,
  onClickEdit,
}: ProfileProductsIndustryProps) => {
  const { t } = useTranslation('screenProfileShow')

  const [activeItems, setActiveItems] = useState(['products-industry'])

  const isComplete = checkIfProductsIndustryIsComplete(lead)

  return (
    <div className={styles.core}>
      <CustomAccordion
        activeItems={activeItems}
        setActiveItems={setActiveItems}
        id="products-industry"
        title={`5. ${t('generalViewGeneralInformationProductsIndustryTitle')}`}
        isComplete={isComplete}
      >
        <div className={styles['info-block']}>
          <div className={styles['info-row']}>
            <div className={styles['info-row-content']}>
              <Text className={styles['info-item']}>
                <strong>{t('generalViewProductsIndustryProductLabel')}:</strong>{' '}
                {lead?.productOfInterest || '-'}
              </Text>

              <Text className={styles['info-item']}>
                <strong>
                  {t('generalViewProductsIndustryIndustryLabel')}:
                </strong>{' '}
                {lead?.industry || '-'}
              </Text>

              <Text className={styles['info-item']}>
                <strong>
                  {t('generalViewProductsIndustryProductionLabel')}:
                </strong>{' '}
                {lead?.companyManufacturedProduct || '-'}
              </Text>
            </div>

            <Button
              variant="secondary"
              className={styles.edit}
              size="small"
              onClick={onClickEdit}
            >
              <EditIcon />
            </Button>
          </div>
        </div>
      </CustomAccordion>
    </div>
  )
}
